module.exports = __webpack_public_path__ + "static/media/tittle3.420e86eb.jpg";